import React from "react";
import OperatingSystemUtility from "./utilities/OperatingSystemUtility";

export default class Referrer extends React.Component {

      private static readonly ANDROID_URL = 'https://play.google.com/store/apps/details?id=it.carfind&referrer=';
      private static readonly IOS_URL = 'https://apps.apple.com/us/app/reach-the-pet/id6499559354?referrer=';

      public componentDidMount(): void {
            const pathName = window.location.pathname.replace('/ref/', '');
            let url: string | undefined = undefined;
            switch (pathName) {
                  case 'inf2': {
                        url = this.createUrl('miosorgente', 'miomedium', 'miocontenuti');
                        break;
                  }
                  default: break;
            }
            if (!this.isEmpty(url)) {
                  window.location.replace(url!);
            }
      }

      public render(): React.ReactNode {
            return <></>;
      }

      private isEmpty(s?: string): boolean {
            return !s || s.trim().length === 0;
      }

      private createUrl(utmSource: string, utmMedium: string, utmContent?: string): string {
            let url = '';
            if (OperatingSystemUtility.isAndroid()) url = Referrer.ANDROID_URL;
            else if (OperatingSystemUtility.isIOS()) url = Referrer.IOS_URL;
            url = this.addParam(url, 'utm_source', utmSource);
            url = this.addParam(url, 'utm_medium', utmMedium);           
            url = this.addParam(url, 'utm_content', utmContent);
             //url = this.addParam(url, 'utm_term', utmTerm);
            //url = this.addParam(url, 'utm_campaign', utmCampaign);
            url = this.addParam(url, 'utm_custom', 'true');
            return url;
      }

      private addParam(url: string, key: string, value?: string): string {
            if (this.isEmpty(value)) return url;
            if (url.includes('%3D')) url += '%26';
            return `${url}${key}%3D${value}`;
      }

}